<div class="confirmation-page" *ngIf="order">

    <!-- Header -->
    <div class="conf-header">
        <button class="back-btn" (click)="goHome()">
            <i class="bi bi-arrow-left"></i>
        </button>
        <span class="header-title">{{ 'ORDER_CONF.TITLE' | translate }}</span>
    </div>

    <div class="page-content">

        <!-- Thank you card -->
        <div class="thankyou-card">
            <div class="check-circle">
                <i class="bi bi-check-lg"></i>
            </div>
            <div class="thankyou-text">
                <p class="thankyou-title">{{ 'ORDER_CONF.THANK_YOU' | translate }}</p>
                <p class="order-number">
                    {{ 'ORDER_CONF.ORDER_NUMBER' | translate }}
                    <strong>#{{ order.orderNumber }}</strong>
                    {{ 'ORDER_CONF.HAS_BEEN_PLACED' | translate }}
                </p>
            </div>
        </div>

        <!-- Email notice -->
        <p class="email-notice">
            {{ 'ORDER_CONF.EMAIL_SENT' | translate }}
            <strong>{{ order.customerEmail }}</strong>
            {{ 'ORDER_CONF.WITH_ORDER_BILL' | translate }}
        </p>

        <!-- Time placed -->
        <p class="time-placed">
            {{ 'ORDER_CONF.TIME_PLACED' | translate }}: {{ formatDate(order.createdAt) }}
        </p>

        <!-- Items -->
        <div class="items-card">
            <div *ngFor="let item of order.items; trackBy: trackByItem; let last = last">
                <div class="item-row">
                    <img [src]="item.imageUrl || 'assets/placeholder.png'" [alt]="item.productName" class="item-img" />
                    <div class="item-info">
                        <p class="item-title">{{ item.productName }}</p>
                        <p class="item-color">
                            <span class="color-dot" [style.background]="item.colorCode"></span>
                            {{ item.colorName }}
                        </p>
                        <p class="item-size">{{ item.size }}</p>
                    </div>
                    <div class="item-qty">×{{ item.quantity }}</div>
                </div>
                <div class="row-divider" *ngIf="!last"></div>
            </div>
        </div>

        <!-- Address -->
        <div class="info-card">
            <i class="bi bi-geo-alt info-icon"></i>
            <span>{{ order.streetAddress }}, {{ order.region }}, {{ order.city }}</span>
        </div>

        <!-- Contact -->
        <div class="info-card">
            <i class="bi bi-person info-icon"></i>
            <div class="contact-lines">
                <p>{{ order.customerEmail }}</p>
                <p>{{ order.customerPhone }}</p>
            </div>
        </div>

        <!-- Order Summary -->
        <div class="summary-section">
            <p class="summary-title">{{ 'ORDER_CONF.ORDER_SUMMARY' | translate }}</p>

            <div class="summary-row">
                <span>{{ 'ORDER_CONF.SUBTOTAL' | translate }}</span>
                <span>{{ order.subtotal | currency:'EGP':'symbol':'1.0-0' }}</span>
            </div>

            <div class="summary-row discount-row" *ngIf="discount > 0">
                <span>{{ 'ORDER_CONF.DISCOUNT' | translate }}</span>
                <span>-{{ discount | currency:'EGP':'symbol':'1.0-0' }}</span>
            </div>

            <div class="row-divider"></div>

            <div class="summary-row total-row">
                <span>{{ 'ORDER_CONF.TOTAL' | translate }}</span>
                <span>{{ order.total | currency:'EGP':'symbol':'1.0-0' }}</span>
            </div>
        </div>

        <!-- Footer buttons -->
        <div class="footer-btns">
            <button class="btn-home" (click)="goHome()">
                {{ 'ORDER_CONF.HOMEPAGE' | translate }}
            </button>
            <button class="btn-shop" (click)="goShopping()">
                {{ 'ORDER_CONF.CONTINUE_SHOPPING' | translate }}
            </button>
        </div>

    </div>
</div>